import {handleLogout} from "components/utils";
import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import {Button, Col, Form, Row} from "react-bootstrap";
import axios from "axios";
import 'react-vertical-timeline-component/style.min.css';
import {randomString} from "../../../utils";
import Editor from "react-simple-wysiwyg";
import {Typeahead} from "react-bootstrap-typeahead";
import {RichEditor} from "../../consentForms/RichEditor";

export const AddProcedureView = (props: { cookieEntityQr: string, caseId: string, postAction: any, doctors: Array<any>, procedureData: any }) => {


    const [successMessage, setSuccessMessage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [drIncharge, setDrIncharge] = useState<string>(props.doctors && props.doctors[0]["clientName"]);
    const [procedureName, setProcedureName] = useState<string>();
    const [procedureDetails, setProcedureDetails] = useState("Assisting Doctors : \n" +
        "Anaesthetist : \n" +
        "Anaesthesia : \n" +
        "Type of Anaesthesia : \n" +
        "\n" +
        "Details : \n" +
        "\n" +
        "Operation Notes : ");
    const [services, setServices] = useState<Array<any>>();


    function fetchServices() {
        axios.get('/api/backend/inventory/item/fetch/all/' + props.cookieEntityQr + "?type=SERVICE&category=Medical Procedures")
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                setServices(resp.data)
                if (resp.data && resp.data.length > 0) setProcedureName(resp.data[0].name)
            })
            .catch(err => {
                console.error(err);
                if (err.response && err.response!.status && err.response!.status === 403) {
                    handleLogout()
                }
            })
    }

    useEffect(() => {

        if (props.procedureData) {
            setProcedureName(props.procedureData.procedureName)
            setProcedureDetails(props.procedureData.procedureDetails)
            setDrIncharge(props.procedureData.drInCharge)
        }

    }, [props.procedureData])

    useEffect(() => {

        if (props.cookieEntityQr) {
            fetchServices();
        }

    }, [props.cookieEntityQr])


    const handleAddProcedure = (e) => {
        e.preventDefault();
        const itemId = services.filter(s => s.name == procedureName)[0].id

        if (props.procedureData && props.procedureData.id) {
            axios.post('/api/backend/ipd/case/audit/update/' + props.procedureData.id, {
                entityQr: props.cookieEntityQr,
                caseId: props.caseId,
                drInCharge: drIncharge != null ? drIncharge : props.doctors && props.doctors[0]["clientName"],
                procedureName: procedureName,
                procedureDetails: procedureDetails,
                itemId: itemId,
                type: "PROCEDURE"
            }).then(resp => {
                console.log(resp.data)
                props.postAction()
            })
                .catch(err => {
                    setErrorMessage("Error while creating the audit trail")
                    console.error(err);
                    if (err.response && err.response!.status && err.response!.status === 403) {
                        handleLogout()
                    }
                    ;
                }).finally(() => setLoading(false));
        } else {
            axios.post('/api/backend/ipd/case/audit/create/', {
                entityQr: props.cookieEntityQr,
                caseId: props.caseId,
                drInCharge: drIncharge != null ? drIncharge : props.doctors && props.doctors[0]["clientName"],
                procedureName: procedureName,
                procedureDetails: procedureDetails,
                itemId: itemId,
                type: "PROCEDURE"
            }).then(resp => {
                console.log(resp.data)
                props.postAction()
            })
                .catch(err => {
                    setErrorMessage("Error while creating the audit trail")
                    console.error(err);
                    if (err.response && err.response!.status && err.response!.status === 403) {
                        handleLogout()
                    }
                    ;
                }).finally(() => setLoading(false));
        }
    }

    function getAddNewWidget() {
        return <>
            <div className="">
                <Form>
                    <div className="row">
                        <div className="col col-12 my-2">
                            <Form.Label className="text-info fs-7">Procedure / Surgery</Form.Label>
                            <Typeahead
                                clearButton
                                labelKey="name"
                                className="flex-fill"
                                selected={procedureName ? [procedureName] : []}
                                onChange={e => {
                                    setProcedureName(e && e.length > 0 ? e[0]["name"] : null)
                                }}
                                options={services}
                                placeholder="Type to select Procedure..."
                                size="sm"
                            />
                        </div>
                        <div className="col col-12 my-2">
                            <Form.Label className="text-info fs-7">Doctor In-Charge</Form.Label>
                            <Typeahead
                                clearButton
                                labelKey="clientName"
                                className="flex-fill"
                                selected={drIncharge ? [drIncharge] : []}
                                onChange={e => {
                                    setDrIncharge(e && e.length > 0 ? e[0]["clientName"] : null)
                                }}
                                options={props.doctors}
                                placeholder="Type to select Doctor..."
                                size="sm"
                            />
                        </div>
                        <div className="col col-12">
                            <Form.Group className="my-2" controlId="procedureDetails">
                                <Form.Label className="text-info fs-7">Procedure Details</Form.Label>
                                <RichEditor data={procedureDetails} setData={setProcedureDetails} height={400}/>
                            </Form.Group>
                        </div>

                        <div className="my-32">
                            <button className="btn btn-info text-white btn-sm"
                                    onClick={e => handleAddProcedure(e)}>
                                {loading &&
                                    <div className="text-center">
                                        <div className="spinner-border" role="status">
                                        </div>
                                    </div>
                                }
                                {!loading && <>Add Procedure</>}
                            </button>
                            {errorMessage &&
                                <div className="text-danger fs-6">*{errorMessage}</div>
                            }
                        </div>
                    </div>

                </Form>
            </div>
        </>;
    }

    return (
        <>
            {getAddNewWidget()}
        </>
    );
}